import { gql } from 'apollo-boost'

export const REGISTER_BANK_SLIP = gql`
  mutation RegisterBankSlip($input: RegisterPaymentSlipInput!) {
    registerBankSlip(input: $input) {
      message
    }
  }
`
